import { render, staticRenderFns } from "./Cladmin.vue?vue&type=template&id=0f78af75&scoped=true"
import script from "./Cladmin.vue?vue&type=script&lang=js"
export * from "./Cladmin.vue?vue&type=script&lang=js"
import style0 from "./Cladmin.vue?vue&type=style&index=0&id=0f78af75&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f78af75",
  null
  
)

export default component.exports